/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import FilmCarousel from '../lists/FilmCarousel';
import FilmGrid from '../lists/FilmGrid';

import styles from '../../../styles/blocks/films.module.scss';

const propTypes = {
    title: PropTypes.string,
    query: PropTypes.shape({}),
    layout: PropTypes.string,
    isContainer: PropTypes.bool,
    isHorizontalStack: PropTypes.bool,
    className: PropTypes.string,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    title: null,
    query: null,
    layout: null,
    isContainer: false,
    isHorizontalStack: false,
    className: null,
    containerClassName: null,
};

const FilmsQueryBlock = ({
    title,
    query,
    layout,
    isContainer,
    isHorizontalStack,
    className,
    containerClassName,
}) => (
    <div
        className={classNames({
            [styles.container]: true,
            [styles[layout]]: layout !== null,
            [className]: className !== null,
        })}
    >
        <div
            className={classNames([
                'blockFilms',
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [styles.isHorizontalStack]: isHorizontalStack,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            {layout === 'grid' ? (
                <FilmGrid
                    title={title}
                    query={query}
                    gridColumns={isHorizontalStack ? 3 : undefined}
                />
            ) : (
                <FilmCarousel title={title} query={query} />
            )}
        </div>
    </div>
);

FilmsQueryBlock.propTypes = propTypes;
FilmsQueryBlock.defaultProps = defaultProps;

export default FilmsQueryBlock;
